export default __webpack_public_path__ + "static/media/preyPoster.37ee6bca.jpg";